import { render } from "./StepComponent.vue?vue&type=template&id=79065205&scoped=true"
import script from "./StepComponent.vue?vue&type=script&lang=js"
export * from "./StepComponent.vue?vue&type=script&lang=js"

import "./StepComponent.vue?vue&type=style&index=0&id=79065205&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79065205"]])

export default __exports__